// The Collectors (docs/04 §16, docs/05 §5). Each attaches one rule to a Reckoning window.
// The first Reckoning is always The Auditor; after that they are drawn without repeats.
import { B } from './balance';
import { defineCollector, type CollectorDef } from './defs';

export const COLLECTOR_LIST: CollectorDef[] = [
  defineCollector({
    id: 'auditor',
    perSpin: true,
    mods: (m) => {
      m.peekRows = 0;
      m.darkReels = true;
    },
  }),
  defineCollector({ id: 'glutton', perSpin: true, mods: (m) => void (m.gluttonEats = true) }),
  defineCollector({
    id: 'widow',
    perSpin: true,
    hexEachSpin: true,
    // Before hexes are unlocked: −1 Luck per spin taken this window, up to −3 (mirrors 3 stacked hexes).
    mods: (m, c) => {
      if (!m.symbolGates.has('hex')) m.luck -= Math.min(B.WIDOW_LUCK_CAP, c.spinsUsed + 1);
    },
  }),
  defineCollector({ id: 'twins', split: true }),
  defineCollector({ id: 'taxman', perSpin: true, mods: (m) => void (m.sqrtXMult = true) }),
  defineCollector({ id: 'mirrorman', perSpin: true, mirror: true, mods: (m) => void (m.mirror = true) }),
  defineCollector({
    id: 'mothqueen',
    perSpin: true,
    mods: (m) => {
      m.halveExceptTags = ['light', 'vermin'];
      m.ageExtraById.candle = (m.ageExtraById.candle ?? 0) + 1;
    },
  }),
  defineCollector({
    id: 'stopwatch',
    perSpin: true,
    mods: (m) => {
      m.features.delete('nudge');
      m.spinsMult *= B.STOPWATCH_SPINS;
      m.payEarlyX *= B.STOPWATCH_PAY_EARLY;
    },
  }),
  defineCollector({ id: 'lastsupper', final: true, rollsRules: true, tributeMult: B.LAST_SUPPER_TRIBUTE_MULT }),
];
